import { reduce } from 'lodash'

import { centsToDollars, toFixed } from '../utils/formatters'

// adds display attributes for fees, subtotal, and total
export const calculateGroupedItems = (groupedItems, percentage) => {
  return reduce(groupedItems, (acc, item) => {
    const quantity = item.quantity ?? 1
    const nextFractionalQuantity = quantity * percentage

    const nextItem = {
      ...item,
      fractionalQuantity: toFixed(nextFractionalQuantity, 2),
      priceInCents: item.priceInCents,
      price: centsToDollars(item.priceInCents),
    }

    return [ ...acc, nextItem ]
  }, [])
}
